import { render, staticRenderFns } from "./IntroductionDescription.vue?vue&type=template&id=600d7a70&"
import script from "./IntroductionDescription.vue?vue&type=script&lang=js&"
export * from "./IntroductionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports